import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderTemplateAddNoteModalForm } from 'application/facility-order/forms';
import { FacilityOrderTemplateNoteService } from "application/facility-order/services";
import { action } from "mobx";

class FacilityOrderTemplateAddNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateNoteService = new FacilityOrderTemplateNoteService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplateNoteId = componentProps.modalParams.data.facilityOrderTemplateNoteId;
        const facilityOrderTemplateId = componentProps.modalParams.data.facilityOrderTemplateId;
        const isActive = componentProps.modalParams.data.isActive;
        super(rootStore, {
            name: 'facility-order-templat-add-note-modal',
            Form: FacilityOrderTemplateAddNoteModalForm,
            id: facilityOrderTemplateNoteId,
            actions: () => {
                return {
                    create: async (resource) => {
                        const response = await facilityOrderTemplateNoteService.create({ ...resource, facilityOrderTemplateId: facilityOrderTemplateId,  isActive: true});
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderTemplateNoteService.update({ ...resource, facilityOrderTemplateId: facilityOrderTemplateId,  isActive: isActive});
                        return response.data;
                    },
                    get: async() =>{
                        const response = await facilityOrderTemplateNoteService.get(facilityOrderTemplateNoteId);
                        return response.data;
                    }
                }
            },
            FormClass: FacilityOrderTemplateAddNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplateNoteId = facilityOrderTemplateNoteId;
        this.note =  this.modalParams.data.note;
        this.facilityOrderTemplateId = this.modalParams.data.facilityOrderTemplateId;
        this.facilityOrderTemplateAddNote = this.modalParams.data.facilityOrderTemplateAddNote;
        this.facilityOrderTemplateUpdateNote = this.modalParams.data.facilityOrderTemplateUpdateNote;
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            let response = await this.actions.create({
                ...resource
            });  
            this.form.setFieldsDisabled(false);
            
            this.facilityOrderTemplateAddNote(response);

            this.modalParams.close();
            await setTimeout(() => this.rootStore.notificationStore.success("FACILITY_ORDER_TEMPLATE.CREATE.NOTE_SUCCESS"), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });  

            this.form.setFieldsDisabled(false);

            this.facilityOrderTemplateUpdateNote(this.id, resource.note);

            this.modalParams.close(); 
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default FacilityOrderTemplateAddNoteModalStore;
